var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-6 action-container" },
    [
      _c(
        "div",
        {
          staticClass:
            "d-flex justify-content-end align-items-center gap-2 mb-2"
        },
        [
          _c(
            "label",
            { staticClass: "block text-sm font-medium text-gray-700 mb-2" },
            [_vm._v(" Tipo de Acción ")]
          ),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.action.type,
                  expression: "action.type"
                }
              ],
              staticClass: "w-full px-3 py-2 border border-gray-300 rounded-lg",
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.$set(
                    _vm.action,
                    "type",
                    $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                  )
                }
              }
            },
            [
              _c("option", { attrs: { value: "" } }, [
                _vm._v("Seleccione una acción")
              ]),
              _vm._l(_vm.ACTION_TYPES_NAMES, function(key, value) {
                return _c(
                  "option",
                  { key: value, domProps: { value: value } },
                  [_vm._v(" " + _vm._s(key) + " ")]
                )
              })
            ],
            2
          ),
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip.hover",
                  value: "Eliminar grupo de condiciones",
                  expression: "'Eliminar grupo de condiciones'",
                  modifiers: { hover: true }
                }
              ],
              staticClass: "shadow",
              attrs: {
                size: "sm",
                variant: "outline-danger",
                title: "Eliminar accion"
              },
              on: {
                click: function($event) {
                  return _vm.$emit("removeAction")
                }
              }
            },
            [_c("feather-icon", { attrs: { icon: "TrashIcon" } })],
            1
          )
        ],
        1
      ),
      _vm.actionFormComponent
        ? _c(_vm.actionFormComponent, {
            tag: "component",
            attrs: { state: _vm.action }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }